import {createDivIn} from '../../ui_utils/DomUtils'
import UIGameSettingsButton from './UIGameSettingsButton'
import {GameSettings} from '@colonist/game-base-types'
import {UIGameHelpButtonsController} from './UIGameHelpButtonsController'
import {UIGameManager} from '../UIGameManager'
import {UIGameInformationButton} from './ui_game_help_buttons_information_button/UIGameInformationButton'
import {UIGameMechanic} from '../UIGameEventController'
import {GameStateEnums} from '../../../../../shared/GameEnums'
import UIGameRulesButton from './UIGameRulesButton'
import {BeginnerModeActionState} from '@colonist/game-state-types'
import {HiddenUIElement} from '@colonist/game-beginner-mode'
import {UIUtilsEjsVariables} from '../../UIUtilsEjsVariables'

export abstract class UIGameHelpButtons implements UIGameMechanic {
    protected readonly uiGameManager: UIGameManager
    protected readonly uiGameHelpButtonController: UIGameHelpButtonsController
    protected rulesButton: UIGameRulesButton

    readonly upperLeftContainer: HTMLDivElement

    readonly helpButtonsContainer: HTMLDivElement
    readonly spectatorsContainer: HTMLDivElement

    readonly settingsButton?: UIGameSettingsButton
    informationButton: UIGameInformationButton | undefined

    constructor(uiGameManager: UIGameManager, helpButtonsController: UIGameHelpButtonsController, gameSettings: GameSettings) {
        this.uiGameManager = uiGameManager
        this.uiGameHelpButtonController = helpButtonsController
        this.uiGameManager.eventController.registerUIGameMechanic(this)

        // If this element has already been created then destroy it
        const existing = document.getElementById('upper-left-container')
        if(existing) existing.remove()

        this.upperLeftContainer = createDivIn(document.body, 'upper-left-container', 'upper-left-container')
        this.helpButtonsContainer = createDivIn(this.upperLeftContainer, 'help-buttons-container', 'help_buttons_section')

        const hideSettings = this.uiGameManager.gameController.isReplay && UIUtilsEjsVariables.isUserOnMobile && !UIUtilsEjsVariables.isUserOnDiscordMobile
        if(!hideSettings) this.settingsButton = new UIGameSettingsButton(helpButtonsController, this.helpButtonsContainer)

        this.spectatorsContainer = createDivIn(this.upperLeftContainer, 'spectators-container', 'spectators_section')
        this.createOtherHelpButtons(gameSettings)

        this.resize()
    }

    onEvent(data: any, eventType: GameStateEnums.UIGameEventEnums) {
        switch(eventType) {
            case GameStateEnums.UIGameEventEnums.GameEndHideMap: this.hide(); break
            case GameStateEnums.UIGameEventEnums.GameEndShowMap: this.show(); break
            case GameStateEnums.UIGameEventEnums.BeginnerModeStart: this.onBeginnerModeStart(); break
            case GameStateEnums.UIGameEventEnums.BeginnerModeActionUpdated: this.onBeginnerModeActionUpdate(data); break
            default: break
        }
    }

    protected onBeginnerModeStart() {
        if(this.informationButton != undefined) this.informationButton.gameHelpButtonContainer.style.display = 'none'
        if(this.rulesButton != undefined) this.rulesButton.gameHelpButtonContainer.style.display = 'none'
    }

    protected onBeginnerModeActionUpdate(data: BeginnerModeActionState) {
        if(data.hiddenUIElements.includes(HiddenUIElement.InformationButton)) return
        if(this.informationButton == undefined) return
        this.informationButton.gameHelpButtonContainer.style.display = ''
        this.informationButton.overrideContentForBeginnerMode(data.actionIndex)
    }

    protected abstract createOtherHelpButtons(gameSettings: GameSettings)

    resize() {
        const canvas = this.uiGameManager.canvasController
        const marginWidth = canvas.responsiveController.getCanvasX()
        const marginHeight = canvas.responsiveController.getCanvasY()

        this.upperLeftContainer.style.margin = `${marginHeight}px 0 0 ${marginWidth}px`
    }

    closeAllContainers() {
        this.settingsButton?.setContainerActive(false)
        this.informationButton?.setContainerActive(false)
    }

    hide() {
        this.closeAllContainers()
        this.upperLeftContainer.style.display = 'none'
    }

    show() {
        this.upperLeftContainer.style.display = ''
    }
}
